var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('thumb',{attrs:{"move":_vm.moveX,"ratio":_vm.ratioX,"size":_vm.width,"always":_vm.always}}),_c('thumb',{attrs:{"move":_vm.moveY,"ratio":_vm.ratioY,"size":_vm.height,"vertical":"","always":_vm.always}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }